<template>
    <div class="question">
        <div v-if="question.image" class="image-holder"><div class="image" :style="{'background-image': `url('${SCHEMA_STORAGE}${question.image}')`}"></div></div>
        <h3>{{ question.title }}</h3>
        <p v-if="question.description" class="description" v-html="safe_html(question.description)"></p>
        <CheckboxControl v-if="question.mode === 'checkbox'" :question="question" @answered="callback" />
        <RadioControl v-else-if="question.mode === 'radio'" :question="question" @answered="callback" />
        <RateControl v-else-if="question.mode === 'rate'" :question="question" @answered="callback" />
        <MessageControl v-else-if="question.mode === 'message'" :question="question" @answered="callback" />
        <TextControl v-else :question="question" @answered="callback" />
    </div>
</template>

<script>
  import ArrayHelpers from './../utils/ArrayHelpers';
  import CheckboxControl from './Controls/Checkbox'
  import RadioControl from './Controls/Radio'
  import RateControl from './Controls/Rate'
  import MessageControl from './Controls/Message'
  import TextControl from './Controls/Text'

  export default {
    name: 'Question',
    props: ['question', 'callback', 'do_shuffle'],
    created: function () {
      if (this.$props.question.options && this.$props.question.options.flags && this.$props.question.options.flags.includes('shuffle')){
        if (this.$props.do_shuffle) {
          this.$props.question.options.items = ArrayHelpers.shuffle(this.$props.question.options.items).sort((a, b) => {
            return (a.hasOwnProperty('order') ? a['order'] : 0) - (b.hasOwnProperty('order') ? b['order'] : 0);
          });
        }
      }
    },
    components: {
      CheckboxControl, RadioControl, RateControl, TextControl, MessageControl
    },
    methods: {
      'safe_html': (html) => {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        let text = tmp.textContent || tmp.innerText || "";
        text = text.split(' _').join(' <strong>').split('_').join('</strong>');
        return text;
      }
    }
  }
</script>

<style>
    .question {
    }
    .question > h3 {
        text-align: center;
        font-size: 1.6rem;
        font-weight: bold;
    }
    .question > p {
        font-size: 1.1rem;
        line-height: 1.5rem;
        margin-top: 0.5rem;
        text-align: center;
        white-space: pre-line;
    }
    .question > div {
        margin-top: 1rem;
    }
    .question > .image-holder,
    .question > .image-holder > .image {
        height: 20rem;
    }

    .question > .image-holder {
        margin: -2rem 0 2rem 0;
    }
    .question > .image-holder > .image {
        background: 50% 100% no-repeat;
        background-size: contain;
        position: absolute;
        left: 0;
        right: 0;
    }
    .radio-container,
    .checkbox-container {
        border: 1px solid #dddddd;
        border-top: none;
    }
    .radio-container li,
    .checkbox-container li {
        background: #ffffff;
        box-shadow: 0 1px 0 rgba(0,0,0,0.13) inset;
    }
    .radio-container li.selected > label,
    .checkbox-container li.selected > label {
        background: #8fbd52;
        color: #ffffff;
    }
    .radio-container li label,
    .checkbox-container li label {
        line-height: 1.2rem;
        padding: 0.7rem;
        display: block;
    }
    .radio-container li label > input,
    .checkbox-container li label > input {
        margin-right: 0.5rem;
        width: 1.2rem;
        height: 1.2rem;
        vertical-align: top;
    }
    @media only screen and (max-width: 640px) {
        .question > .image-holder {
            margin: -1.5rem 0 1.5rem 0;
        }
        .question > .image-holder,
        .question > .image-holder > .image {
            height: 15rem;
        }
    }
    @media only screen and (max-width: 480px) {
        .question > .image-holder,
        .question > .image-holder > .image {
            height: 10rem;
        }
    }
    @media only screen and (min-width: 1024px){
        .question > h3 {
            max-width: 50rem;
            margin-left: auto;
            margin-right: auto;
        }
        .question > p {
            margin-top: 0.7rem;
            margin-left: auto;
            margin-right: auto;
            max-width: 50rem;
        }
        .question > div {
            margin-top: 2rem;
        }
        .question > .image-holder {
            margin: -3rem 0 3rem 0;
        }
    }
</style>
